<div class="flex items-center gap-2 text-alert-base text-[14px] font-semibold">
  <span>{{ text }}</span>
  <img
    src="assets/svg/alert.svg"
    alt="alert"
    class="w-4 h-4" />
</div>
